export function bindToHashParameter({ variable, parameter, replace, parseValue, defaultValue }) {
	let lastValue
	let parameterRegex = new RegExp('&*' + parameter + '=([^&]*)')
	function updateVariableFromHash() {
		let value = location.hash.match(parameterRegex)?.[1]
		if (value != lastValue) {
			value = value || defaultValue
			lastValue = value
			const decoded = value && decodeURIComponent(value)
			variable.is(parseValue ? parseValue(decoded) : decoded)
		}
	}
	updateVariableFromHash()
	addEventListener('popstate', updateVariableFromHash)
	let first = true
	variable.subscribe(() => {
		if (first) {
			first = false
			return
		}
		let hash = location.hash.replace(parameterRegex, '').replace(/^#&*/, '')
		lastValue = variable + ''
		hash = '#' + hash + (variable.valueOf() == undefined ? '' :
			((hash ? '&' : '') + parameter  + '=' + variable))
		if (hash != (location.hash || '#'))
			history[replace ? 'replaceState' : 'pushState']({}, null, hash)
	})

}